import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ProformaInvoiceItemDTO {
  productId: string;
  productName: string;
  hsnCode: string;
  quantity: number;
  mrp: number;
  offerPrice: number;
  taxRate: number;
  finalPrice: number;
}

export interface ProformaInvoiceDTO {
  id: number;
  buyerName: string;
  buyerPhoneNumber: string;
  buyerGst: string;
  status: string;
  numberOfItems: number;
  totalAmount: number;
  linkToPdf: string;
  items: ProformaInvoiceItemDTO[];
}

@Injectable({
  providedIn: 'root',
})
export class ProformaService {
  private baseUrl = environment.API_URL + '/cart';

  constructor(private http: HttpClient) {}

  getAll(): Observable<ProformaInvoiceDTO[]> {
    return this.http.get<ProformaInvoiceDTO[]>(
      `${this.baseUrl}/getAllProforma`
    );
  }

  getById(id: number): Observable<ProformaInvoiceDTO> {
    return this.http.get<ProformaInvoiceDTO>(
      `${this.baseUrl}/getProformaById/${id}`
    );
  }

  update(proforma: ProformaInvoiceDTO): Observable<ProformaInvoiceDTO> {
    return this.http.post<ProformaInvoiceDTO>(
      `${this.baseUrl}/editProforma`,
      proforma
    );
  }
}
